<template>
  <div>
    <div class="modal" v-show="show">
      <div class="modal__logout">
        <div class="modal__logout__msg">
          <p>是否要注销帐号</p>
          <p class="modal__logout__urs">是否要退出客服系统</p>
        </div>
        <div class="modal__logout__btn" @click="cshow">取消</div>
        <div class="modal__logout__btn" @click="logout">确认</div>
      </div>
    </div>
    <div class="header">
      <div class="l-wrap">
        <a class="header__logo" href="https://www.zhaouc.com/" target="_blank">塔人网络</a>
		<el-dropdown class="news_nav">
			<span>
				游戏充值
			</span>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item><a href="http://pay.tarenwang.com/" target="_blank">MU、SUN</a></el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-dropdown class="news_nav">
			<span>
				帐号管理
			</span>
			<el-dropdown-menu slot="dropdown">
			    <el-dropdown-item><a href="http://yht.zhaouc.com/" target="_blank">MU、SUN</a></el-dropdown-item>
			    <el-dropdown-item><a href="http://roinfo.zhaouc.com/" target="_blank">RO</a></el-dropdown-item>
				<el-dropdown-item><a href="http://my.zhaouc.com/" target="_blank">新一号通</a></el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<a class="news_nav" href="http://www.zhaouc.com/" target="_blank">塔人主站</a>
		<a class="news_nav" href="/">客服首页</a>
		<a class="login__not" v-show="show1" @click='$router.push({path:"/clogin"})'>登录</a>
        <div class="login__already" v-show="show2">
          <div>
            <a><i msg-icon=""></i>&nbsp;&nbsp;{{name}}</a>
			<a @click='$router.push({path:"/tracklist"})'>服务记录追踪</a>
			<a @click="logout">切换账户</a>
            <a @click="ifshow" class="J-logout-btn"> 注销</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Top",
		data () {
		  return {
			show:false,
			show1:false,
			show2:false,
			name:''
		  }
		},
		methods:{
			ifshow(){
				this.show=true
			},
			cshow(){
				this.show=false
			},
			logout(){
				this.$axios({
				  method: 'get',
				  url: '/index.php/user/User/loginout',
				})
				this.show=false
				localStorage.clear();
				document.cookie=''
				this.$router.push({path:"/clogin"})
			}
		},
		created() {
		  function getCookie(cname)
		  {
		    var name = cname + "=";
		    var ca = document.cookie.split(';');
		    for(var i=0; i<ca.length; i++)
		    {
		      var c = ca[i].trim();
		      if (c.indexOf(name)==0) return c.substring(name.length,c.length);
		    }
		    return "";
		  }
		  let uid=getCookie('user_name')
		  if(!uid){
		    this.show1=true
		    this.$router.push({path:"/clogin"})
		  }else{
			var ph = localStorage.getItem('phone');
			if(ph){
				this.name=decodeURI(uid)
			}else{
				this.name=uid
			}
		    this.show2=true
		  }
		}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/top.vue